import { useEffect, useState } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'assoperf_cookie_consent';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Show after a small delay to avoid layout shift on page load
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-3 left-3 right-3 sm:bottom-5 sm:left-5 sm:right-auto sm:max-w-md z-[9000] bg-white rounded-2xl shadow-2xl border border-slate-200 p-4 sm:p-5 fade-in"
      role="dialog"
      aria-live="polite"
      aria-label="Bandeau cookies"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3 mb-3">
        <div className="w-9 h-9 rounded-lg grid place-items-center shrink-0" style={{ background: 'rgba(0,82,255,0.1)' }}>
          <Cookie className="w-4 h-4" style={{ color: '#0052FF' }} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-sm text-slate-900 mb-1">Cookies essentiels uniquement</div>
          <p className="text-xs text-slate-600 leading-relaxed">
            AssoPerf utilise uniquement des cookies <strong>strictement nécessaires</strong> au fonctionnement
            (authentification, préférences). Aucun cookie publicitaire ni de tracking tiers.
          </p>
        </div>
        <button
          onClick={accept}
          className="text-slate-400 hover:text-slate-700 shrink-0"
          aria-label="Fermer"
          data-testid="cookie-close"
        ><X className="w-4 h-4" /></button>
      </div>
      <div className="flex flex-wrap gap-2 items-center">
        <button
          onClick={accept}
          className="btn-primary !text-xs !py-2 !px-4 flex-1 sm:flex-none"
          style={{ background: '#0052FF' }}
          data-testid="cookie-accept"
        >J'ai compris</button>
        <Link
          to="/confidentialite"
          className="text-xs text-slate-500 hover:text-slate-900 underline px-2"
          data-testid="cookie-learn-more"
        >En savoir plus</Link>
      </div>
    </div>
  );
}
